import { render, staticRenderFns } from "./shareCodePost.vue?vue&type=template&id=73e27139&scoped=true"
import script from "./shareCodePost.vue?vue&type=script&lang=js"
export * from "./shareCodePost.vue?vue&type=script&lang=js"
import style0 from "./shareCodePost.vue?vue&type=style&index=0&id=73e27139&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e27139",
  null
  
)

export default component.exports